<template>
  <div class="QuestionManagement">
    <AppHeader>问题管理</AppHeader>
    <AppBox class="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="系列名称">
            <el-select
              style="width: 150px"
              v-model="filter.classSubjectId"
              v-scroll="loadMore"
              placeholder="请选择"
              @change="onSubmit"
            >
              <el-option
                v-for="item in classNameList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回答状态">
            <el-select
              style="width: 100px"
              v-model="filter.states"
              placeholder="请选择"
              @change="onSubmit"
            >
              <el-option
                v-for="item in answerStateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提问日期">
            <el-date-picker
              style="width: 250px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filter.keyword"
              placeholder="课程名称"
              @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <QuestionResponseList></QuestionResponseList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import { ANSWER_STATES } from "@/utils/constants";
import QuestionResponseList from "@/pages/QuestionManagement/QuestionResponseList.vue";

export default {
  name: "QuestionManagement",
  components: { QuestionResponseList, AppHeader, AppBox },
  data() {
    const answerStateOptions = Object.keys(ANSWER_STATES).map((key) => {
      return {
        value: Number(key),
        label: ANSWER_STATES[key],
      };
    });
    return {
      answerStateOptions: [
        {
          value: null,
          label: "全部",
        },
        ...answerStateOptions,
      ],
      classNameList: [
        {
          id: null,
          name: "全部",
        },
      ],
    };
  },
  watch: {
    "$route.params.lessonName": async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$set(this.filter, "keyword", newVal);
        await this.getLessonQuestionResponseList({
          ...this.filter,
          page: 1,
        });
      }
    },
  },
  computed: {
    ...mapState("teachingCenter", ["seriesList"]),
    filter: {
      get() {
        return this.$store.state.courseCenter.questionResponseListFilter;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "questionResponseListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    const name = this.$route.params.lessonName;
    this.$set(this.filter, "keyword", name);
    // await this.getLessonQuestionResponseList({
    //   ...this.filter,
    //   page: 1,
    // });
    await this.getSeriesList({});
    this.classNameList = this.classNameList.concat(this.seriesList.data);
  },
  methods: {
    ...mapActions("courseCenter", ["getLessonQuestionResponseList"]),
    ...mapActions("teachingCenter", ["getSeriesList"]),
    ...mapMutations("courseCenter", ["clearFilter"]),
    async loadMore() {
      const currentPage = this.seriesList.page;
      const currentSize = this.seriesList.size;
      const currentTotal = this.seriesList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getSeriesList({
          page: this.seriesList.page + 1,
        });
        this.classNameList = this.classNameList.concat(this.seriesList.data);
      }
    },
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getLessonQuestionResponseList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearFilter();
      // this.$set(this.filter, "departmentId", this.userDepartmentDictionary[0].id)
      await this.getLessonQuestionResponseList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.QuestionManagement {
  .appBox {
    height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
